export default __webpack_public_path__ + "static/media/arrow_point_up.db5ea7ef.svg";